import React, { Children } from "react";
import { Link } from "react-router-dom";

const TopRightLink = ({ name, url, children, disabled }) => {
  const isButton = !!name;
  if(!disabled) return (
    <Link
      className={
        isButton ? `btn btn-primary font-weight-bold letter-spacing btn-md` : ""
      }
      to={typeof url === "string" ? url : url?.pathname}
      state={url?.state}
    >
      {isButton ? name : children}
    </Link>
  )
  else return (
    <span
      className={
        isButton ? `btn btn-primary font-weight-bold letter-spacing btn-md disabled` : ""
      }
    >
      {isButton ? name : children}
    </span>
  )
};

export default TopRightLink;
